import {select, take, fork, put} from 'redux-saga/effects';
import {replace, resolveRoute} from '@computerrock/formation-router';
import * as invoiceActionTypes from '../invoiceActionTypes';
import fetchRequest from '../../application/sagas/fetchRequest';
import routePaths from '../../routePaths';

const invoiceCopyCreationFlow = function* () {
    const {serviceManager} = yield select(state => state.application);
    const leaAssignmentFlowService = serviceManager.loadService('leaAssignmentFlowService');

    while (true) {
        const {payload} = yield take(invoiceActionTypes.INITIATE_INVOICE_COPY_CREATION);
        const {invoiceId} = payload;

        yield fork(fetchRequest,
            invoiceActionTypes.CREATE_INVOICE_COPY_REQUEST,
            leaAssignmentFlowService.copyInvoice,
            {invoiceId});

        const responseAction = yield take([
            invoiceActionTypes.CREATE_INVOICE_COPY_REQUEST_SUCCEEDED,
            invoiceActionTypes.CREATE_INVOICE_COPY_REQUEST_FAILED,
        ]);

        if (responseAction.type === invoiceActionTypes.CREATE_INVOICE_COPY_REQUEST_SUCCEEDED) {
            const {response} = responseAction.payload;
            const {invoiceDTO} = response;

            yield put({
                type: invoiceActionTypes.STORE_INVOICES,
                payload: {invoiceDTOs: [invoiceDTO]},
            });

            yield put(replace(resolveRoute(routePaths.INVOICES, {
                serviceCaseId: invoiceDTO.serviceCaseId,
                invoiceId: invoiceDTO.id,
            })));
        }
    }
};

export default invoiceCopyCreationFlow;
